import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 280,
      sm: 320,
      md: 768,
      lg: 1024,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#115bab",
      light: "#2378d4",
      dark: "#0f4a8a",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#5d2cff",
    },
    text: {
      secondary: "#60768e",
    },
    error: {
      main: "#e55353",
    },
    // error: {
    // 	main: "red",
    // },
    grey: {
      50: "#f8f8f8", // light gray
      100: "#e3e3e3", // mid light gray
      200: "#b1b1b1", // mid dark gray
      300: "#747474", // dark gray
      400: "#333333", // black
      500: "#ffffff",
      600: "#60768e",
    },
    background: {
      default: "#f5faff",
    },
  },
  typography: {
    h1: {
      // fontSize: 6,
      fontWeight: 700,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
    },
    h2: {
      fontSize: 40,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
    },

    h3: {
      fontSize: 24,
      fontWeight: 600,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
    },
    h4: {
      fontSize: 20,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      lineHeight: 1.6,
      // color: "#333333",
    },
    h5: {
      fontSize: 18,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#333333",
    },
    h6: {
      fontSize: 16,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#60768e",
    },
    body1: {
      // fontSize: 40,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#333333",
    },
    body2: {
      fontSize: 20,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#333333",
    },
    caption: {
      fontSize: 12,
      fontWeight: 500,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#747474",
    },
    button: {
      fontSize: 16,
      fontWeight: 400,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#333333",
    },
    div: {
      fontSize: 14,
      fontWeight: 400,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#333333",
    },
    overline: {
      fontSize: 14,
      fontWeight: 600,
      fontFamily: `NanumSquareRound, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI,  Oxygen,
		Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
      color: "#333333",
    },
  },
});

export default theme;
